import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import isEqual from 'lodash/isEqual';
import { SelectDropdown } from '@adsk/bim360-matrix-react-components';
import { issueAttributesType } from '../../../../../../../constants/proptype-validation';
import IssueFieldInlineEdit from '../../../../../../IssueFieldInlineEdit';
import FilterSearchIcon from '../../../../../../FilterSearchIcon';
import { ISSUE_ATTRIBUTE_NAMES } from "../../../../../../../constants/issue-attribute-names";

class CategoryInlineEdit extends PureComponent {

  constructor(props) {
    super(props);
    const { issue } = this.props;

    this.state = {
      value: issue[ISSUE_ATTRIBUTE_NAMES.CATEGORY],
    };
  }

  render() {
    const { issue, categories, className, label, container, styleType } = this.props;
    return (
      <div>
        <IssueFieldInlineEdit
          issue={issue}
          className={className}
          data-testid={this.props['data-testid']}
          attributeName={ISSUE_ATTRIBUTE_NAMES.CATEGORY}
          label={label}
          getDisplayValue={(currentValue) => {
            return categories.filter(u => currentValue && currentValue.includes(u.key)).map(u => u.label).join(', ');
          }}
          placeholder={T.translate('unspecifiedValue')}
          container={container}
          styleType={styleType}
          horizontalAlign
        >
          {(currentValue, closeEditMode, updateIssue) => <SelectDropdown
            selectedOptions={categories.filter(u => this.state.value && this.state.value.includes(u.key))}
            autofocus
            openOnFocus
            multi
            backspaceRemoves={false}
            options={categories}
            searchable
            searchPlaceholder={T.translate('search')}
            searchIcon={<FilterSearchIcon />}
            onClose={closeEditMode}
            onChange={(options) => {
              const value = options.map(o => o.key);
              this.setState({ value });
            }}
            onBlur={() => {
              const { value } = this.state;
              if (!isEqual(value, issue[ISSUE_ATTRIBUTE_NAMES.CATEGORY])) {
                updateIssue(this.state.value);
              }
            }}
          />}
        </IssueFieldInlineEdit>
      </div>
    );
  }
}

CategoryInlineEdit.displayName = 'CategoryInlineEdit';


CategoryInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  categories: PropTypes.array.isRequired,
  infoMessage: PropTypes.string,
  container: PropTypes.object,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
};

export default CategoryInlineEdit;
